import React from 'react';
import Card from './Card';

interface FormSectionProps {
  id: string;
  title: string | React.ReactNode;
  subtitle?: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  columns?: 1 | 2 | 3 ;
}

const FormSection: React.FC<FormSectionProps> = ({ 
  id, 
  title, 
  subtitle,
  headerActions,
  children,
  columns = 2
}) => {
  const gridClasses = {
    1: '',
    2: 'grid grid-cols-1 md:grid-cols-2 gap-4',
    3: 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4',
  };

  return (
    <div id={id} className="mb-8">
      <Card
        title={title}
        subtitle={subtitle}
        headerActions={headerActions}
      >
        <div className={gridClasses[columns]}>
          {children}
        </div>
      </Card>
    </div>
  );
};

export default FormSection;